<template>
  <div id="increase_price">
    <el-dialog
      title="批量支付"
      :visible.sync="markupshow"
      @close="cancelPrice"
      :append-to-body="true"
      class="remark_modal"
      id="orderlist"
    >
      <div class="markup-t">
        <batchOrder-list ref="orderRow" :info="orderList"></batchOrder-list>
        <div class="increase_price_form">
          <el-row :gutter="36">
            <el-col :span="8">
              <div class="zhuijia amount_tit">
                应付总额
                <span class="amount_text">¥{{ markupPrice }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="pay_type">
            <div class="zf-tit">支付方式</div>
            <div class="pay_modes">
              <div
                v-if="isShow('WALLET')"
                class="pay_mode"
                :class="{ pay_selected: payMode[0].selected }"
                @click="payMethod('WALLET')"
              >
                <svg class="icon icona_xiadan_yue" aria-hidden="true">
                  <use xlink:href="#icona_xiadan_yue" />
                </svg>
                <div class="pay_mode_right">余额支付</div>
              </div>
            </div>
          </el-row>
          <div class="yue_money" v-if="payMode[0].selected">
            余额：¥{{ balance }} <a @click="balanceUptodate">点击刷新</a>
          </div>
          <div
            class="recharge"
            v-if="payMode[0].selected && markupPrice - balance >= 0"
          >
            您的余额不足
            <span @click="goRecharge()" style="cursor: pointer">
              前往充值
              <i class="iconfont iconbiaodan_rili_right"></i>
            </span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPrice">取 消</el-button>
        <el-button type="primary" @click="increasePrice()">提 交</el-button>
        <!-- :disabled="markupPrice != '0' && markupPrice != '' ? false : true" -->
      </span>
    </el-dialog>

    <!-- 输入密码 -->
    <el-dialog
      title="输入密码支付"
      :visible.sync="dialogVisible"
      @close="cancelPassword"
      width="30%"
      class="pass"
      :append-to-body="true"
      id="orderlist"
    >
      <div>
        <el-input
          style="width: 100%"
          v-model="verificationCode"
          placeholder="请输入支付密码"
          maxlength="6"
          show-password
          autocomplete="new-password"
          class="default-input"
        ></el-input>
        <!-- :type="passwordType" -->
        <!-- <svg
          class="icon"
          aria-hidden="true"
          v-show="icon && passwordType == 'password'"
          @click="passType(passwordType)"
        >
          <use xlink:href="#icontanchuang_guanbichakan" />
        </svg>
        <svg
          class="icon"
          aria-hidden="true"
          v-show="icon && passwordType == 'text'"
          @click="passType(passwordType)"
        >
          <use xlink:href="#icontanchuang_chakn" />
        </svg> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="priceMarkup()"
          :disabled="!verificationCode"
          :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 设置支付密码 -->
    <set-passwod
      :showPad="showPad"
      :phoneNum="phoneNum"
      v-on:showPasswod="showPasswod"
    ></set-passwod>
  </div>
</template>

<script>
import setPasswod from "./../set_passwod";
import Clipboard from "clipboard";
import Cookies from "js-cookie";
import batchOrderList from "@/components/user/modules/batchOrderList";
import { postAction } from "@/api/manage";
import { arithmeticAdd } from "@/utils/util";

export default {
  components: {
    setPasswod,
    batchOrderList,
  },
  props: {
    orderData: Object,
    markup: Boolean,
    abnormal: Boolean,
  },
  data() {
    return {
      params: {},
      options: [],
      orderList: [],
      payMode: [
        { selected: true, name: "WALLET" },
        { selected: false, name: "ALIPAY" },
        { selected: false, name: "WECHAT" },
      ],
      payWayEnum: "WALLET",
      markupPrice: 0,
      markupType: "ORDINARY", //加价类型
      errText: false,
      icon: false,
      passwordType: "password",
      phoneNum: "",
      showPad: false,
      verificationCode: "",
      dialogVisible: false,
      balance: "",
      setPad: false,
      getYzm: true,
      yzmImg: false,
      yzmTime: 60,
      yzmTtext: "发送验证码",
      orderPay: false,
      WECHATurl: "",
      loading: false,
      myerval: "",
      markupOrderId: "",
      ispayHtml: false,
      pathStr: "",
      orderPayWay: [],
      remark: "",
      multipleSelection: [],
    };
  },
  mounted() {
    var _this = this;
    if (Cookies.get("token") != undefined) {
      this.balanceUptodate();
      // 获取可用支付方式
      this.$fetch(`/common/platform/get_pay_way`).then((res) => {
        if (res.code == 0) {
          this.orderPayWay = res.data.orderPayWay;
          // 设置默认支付方式
          this.payMethod(res.data.orderPayWay[0]);
        } else {
          this.$message(res.message);
        }
      });
    }
  },
  computed: {
    markupshow: {
      get() {
        return this.markup;
      },
      set() {
        this.cancelPrice();
      },
    },
  },
  methods: {
    init(multipleSelection) {
      console.log(multipleSelection);
      this.multipleSelection = multipleSelection;
      this.getBatchOrder();
    },
    // 获取批量支付订单信息
    getBatchOrder() {
      postAction("/order/api/order/list_by_orderIds", {
        orderIds: this.multipleSelection,
      }).then(({ data }) => {
        if (data.code == 0) {
          this.orderList = data.data;
          this.orderList.map((i) => {
            this.markupPrice = arithmeticAdd(
              this.markupPrice,
              i.originalAmount
            );
          });
        }
      });
    },
    // 获取用户余额
    balanceUptodate() {
      let _this = this;
      this.$fetch(`/user/api/customer/balance`).then((res) => {
        if (res.code == 0) {
          _this.balance = res.data.balance;
          this.$forceUpdate();
        } else {
          this.$message(res.message);
        }
      });
    },
    showPasswod(val) {
      this.showPad = val;
    },
    // 是否显示
    isShow(item) {
      if (this.orderPayWay.indexOf(item) != -1) {
        return true;
      } else {
        return false;
      }
    },
    // 跳转充值
    goRecharge() {
      this.$router.push({ path: "/user/wallet/recharge" });
    },
    // 取消支付
    cancelPrice() {
      this.params = {};
      this.markupPrice = 0;
      this.WECHATurl = "";
      this.remark = "";
      this.multipleSelection = [];
      this.verificationCode = "";
      this.dialogVisible = false;
      this.$parent.batchPayShow = false;
    },
    // 取消密码输入
    cancelPassword() {
      this.verificationCode = "";
    },
    // 支付方式
    payMethod(item) {
      for (let i of this.payMode) {
        i.selected = false;
        if (item == i.name) {
          i.selected = true;
        }
      }
      this.payWayEnum = item;
      clearInterval(this.myerval);
      this.WECHATurl = "";
      // if (item == "WALLET" || item == "ALIPAY") {
      // }
      if (item == "WECHAT") {
        this.paying = false;
        this.weixingPay();
      }
    },
    // 余额支付
    balancePay() {
      for (let i of this.payMode) {
        i.selected = false;
      }
      this.payMode[0].selected = true;
      this.payWayEnum = "WALLET";
      this.WECHATurl = "";
      clearInterval(this.myerval);
    },
    //支付宝
    zhifubaoPay() {
      for (let i of this.payMode) {
        i.selected = false;
      }
      this.payMode[1].selected = true;
      this.payWayEnum = "ALIPAY";
      this.WECHATurl = "";
      clearInterval(this.myerval);
    },
    // 微信支付
    weixingPay() {
      for (let i of this.payMode) {
        i.selected = false;
      }
      this.payMode[2].selected = true;
      this.payWayEnum = "WECHAT";
      this.WECHATurl = "";
      clearInterval(this.myerval);
    },
    // 检查支付宝加价是否成功，成功跳转订单列表
    openOrderList() {
      let _this = this;
      console.log(this.abnormal);
      if (this.abnormal) {
        this.$fetch(`/order/api/markup/${this.markupOrderId}`).then((res) => {
          console.log(res);
          if (res.data.status == "SUCCESS") {
            if (_this.abnormal) {
              _this
                .$post(
                  `/order/api/order/${_this.orderData.id}/solve_exception?solveExceptionWay=MARKUP&amount=${_this.markupPrice}`
                )
                .then((res) => {
                  if (res.code == 0) {
                    this.orderPay = false;
                    _this.cancelPrice();
                    this.$router.go(-1);
                  } else {
                    this.$message(res.message);
                  }
                });
            } else {
              _this.$emit("increasePrice", _this.markupPrice);
              this.$emit("showMarkup", false);
              clearInterval(_this.myerval);
            }
          } else {
            this.orderPay = false;
          }
        });
      } else {
        _this.cancelPrice();
        this.orderPay = false;
        this.$router.go(0);
      }

      // this.$router.push({ name: "allOrder" });
    },
    // // 加价
    // markupCheck(item, index) {
    //   var _this = this;
    //   this.markup = true;
    //   this.$fetch(`/user/api/customer/balance`).then(res => {
    //     if (res.code == 0) {
    //       _this.balance = res.data.balance;
    //     } else {
    //       this.$message(res.message);
    //     }
    //   });
    // },
    // 余额支付判断有无设置支付密码
    increasePrice() {
      // this.$message.closeAll();
      // if (!this.params.markupType)
      //   return this.$message.warning("请先选择加价类型");
      if (this.$store.state.hasPwd) {
        // 余额支付
        if (this.payMode[0].selected) {
          this.dialogVisible = true;
        }
        // 支付宝支付
        if (this.payMode[1].selected) {
          console.log("支付宝");
          this.priceMarkup();
        }
        if (this.payMode[2].selected) {
          console.info("微信");
          this.priceMarkup();
        }
      } else {
        var reg = /^(\d{3})\d{4}(\d{4})$/;
        this.phoneNum = this.$store.state.userPhone.replace(reg, "$1****$2");
        this.showPad = true;
      }
    },

    // 加价支付
    priceMarkup() {
      var _this = this;
      _this.loading = true;
      let params = Object.assign({
        orderIds: this.multipleSelection,
        payWayEnum: "WALLET",
        password: this.verificationCode,
      });
      postAction("/order/api/order/order_batch_pay", params)
        .then(({ data }) => {
          if (data.code == 0){
            this.$message.success("批量支付成功");
            this.$emit('ok')
            this.cancelPrice();
          } else this.$message.error(data.message);
        })
        .finally(() => (this.loading = false));
    },
    // 支付未打开新页面情况下 dialog 关闭的回调
    payHtmlClose() {
      let timer = setTimeout(() => {
        this.orderPay = true;
        clearTimeout(timer);
      }, 300);
    },
    // 立即复制
    copyUrl(e) {
      this.$message.closeAll();
      const clipboard = new Clipboard(e.target, { text: () => this.pathStr });
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.warning("该浏览器不支持自动复制，请手动复制");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    // 查询微信加价是否成功
    markupPriceOrder(orderId) {
      let _this = this;
      this.$fetch(`/order/api/markup/${orderId}`).then((res) => {
        console.log(res);
        if (res.data.status == "SUCCESS") {
          if (_this.abnormal) {
            _this
              .$post(
                `/order/api/order/${_this.orderData.id}/solve_exception?solveExceptionWay=MARKUP&amount=${_this.markupPrice}`
              )
              .then((res) => {
                if (res.code == 0) {
                  this.$router.go(-1);
                } else {
                  this.$message(res.message);
                }
              });
          } else {
            _this.$emit("increasePrice", _this.markupPrice);
            this.$emit("showMarkup", false);
            clearInterval(_this.myerval);
          }
        }
      });
    },
    passType(item) {
      var _this = this;
      if (item == "password") {
        _this.passwordType = "text";
      }
      if (item == "text") {
        _this.passwordType = "password";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-input .el-input__suffix {
  width: auto !important;
}
</style>
<style lang="scss">
.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-textarea__inner:focus,
.el-message-box__input input.invalid,
.el-message-box__input input.invalid:focus {
  border-color: #f56c6c !important;
}
#orderlist .el-dialog {
  width: 459px !important;
}
</style>
<style lang="scss" scoped>
.pay_type {
  display: flex;
  align-items: center;
  .zf-tit {
    margin-right: 9px;
    margin-bottom: 0 !important;
  }
}
.yue_money {
  font-size: 14px !important;
  height: 14px !important;
  margin-left: 65px;
  a {
    margin-left: 16px;
    color: #909399;
    &:hover {
      color: #3455d3;
    }
  }
}
.recharge {
  margin-left: 65px;
}
.pay_modes {
  .pay_mode {
    width: 190px !important;
    height: 100px !important;
    padding: 20px 0 20px 22px !important;
    .icon {
      width: 56px !important;
      height: 56px !important;
      margin-right: 3px !important;
    }
    .pay_mode_right {
      height: 56px !important;
    }
  }
}
#orderlist /deep/ .el-input__inner {
  height: 34px !important;
  margin-top: 0 !important;
}
.increase_price_form {
  background: #fff;
  padding: 20px;
  .zhuijia {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.amount_tit {
      justify-content: flex-start;
    }
    .amount_text {
      color: #f75658;
      font-size: 32px;
      margin-left: 12px;
    }
    .default-input {
      width: 77%;
      &/deep/.el-input__suffix {
        width: auto !important;
      }
    }
    .default-input-remark {
      width: 93%;
      height: 80px;
      &/deep/textarea {
        height: 100%;
        border-radius: 2px;
        font-size: 12px;
        resize: none;
      }
    }
  }
}
#orderlist.remark_modal {
  &/deep/.el-dialog {
    width: 1000px !important;
  }

  &/deep/.el-dialog__body,
  &/deep/.el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }

  &/deep/.el-dialog__body {
    padding: 20px 24px !important;
  }

  &/deep/.el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;

    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
    }
  }

  .gengjiun {
    background: #fff;
    padding: 0 20px 20px;

    .modal-tit {
      height: 54px;
      padding: 20px 0 15px 0;
      font-size: 14px;
      line-height: 19px;
      color: #5e6066;
      font-weight: bold;
    }
  }
}

.default-input {
  /deep/input {
    width: 100%;
  }
}
// #increase_price {
.set-pass {
  .steps {
    color: #909399;
    font-size: 12px;
  }
  .phone {
    color: #2f3133;
    font-size: 14px;
    height: 14px;
    line-height: 1;
    margin-top: 30px;
    margin-bottom: 10px;
    span {
      color: #5e6066;
      margin-right: 6px;
    }
  }
  /deep/ .get_yzm {
    background: transparent !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
/deep/.el-input input {
  border: 1px solid #dcdfe6 !important;
}
/deep/.pass .el-input input {
  border: none !important;
  border-bottom: 1px solid #dcdfe6 !important;
}
// }
</style>
